import { globalEntitlements } from '../utils/globalEntitlements';

const CORP_AMENDMENT_SERVICE_CODE = 'corp_amendment';

const getAmendmentCtaType = (enableAmendmentV2Journey) => (serviceCode) => {
  if (serviceCode === CORP_AMENDMENT_SERVICE_CODE) {
    return 'externalCheckout';
  }
  return enableAmendmentV2Journey ? 'internalCheckout' : 'externalCheckout';
};

export const getAmendmentConfig = (enableAmendmentV2Journey) => ({
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.amendment.buyBox.bulletPoint1' },
          { title: 'productPage.amendment.buyBox.bulletPoint2' },
          { title: 'productPage.amendment.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.amendment.buyBox.productName',
        veloBanner: {
          displayVeloBanner: true,
          prompt: 'tool-amendment-requirements',
          message: 'productPage.common.buyBox.veloBanner.text',
          queryType: 'requirements',
        },
        couponBanner: {
          message: 'productPage.common.buyBox.couponBannerWfc',
        },
        interactService: {
          isBusinessTypeDependent: true,
          service: 'amendment',
          ctaType: getAmendmentCtaType(enableAmendmentV2Journey),
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/apron-tablet-shop.png',
      alt: 'productPage.amendment.heroPicture.altText',
    },
    headline: 'productPage.amendment.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.amendment.page.subheader',
  },
  benefit: {
    title: 'productPage.amendment.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/thumbuprounded.svg',
        title: 'productPage.amendment.valueProp.propTitle1',
        description: 'productPage.amendment.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/keyboarddoublearrowrightrounded.svg',
        title: 'productPage.amendment.valueProp.propTitle2',
        description: 'productPage.amendment.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/phoneiphonerounded.svg',
        title: 'productPage.amendment.valueProp.propTitle3',
        description: 'productPage.amendment.valueProp.shortCopy3',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/checkrounded.svg',
    title: 'productPage.amendment.topFeature.title',
    subheader: 'productPage.amendment.topFeature.subheader',
    image: '/s2/raster/studio-craft-ceramics.png',
    alt: 'productPage.amendment.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.amendment.howItWorks.title',
    items: [
      {
        title: 'productPage.amendment.howItWorks.step1',
        description: 'productPage.amendment.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.amendment.howItWorks.step2',
        description: 'productPage.amendment.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.amendment.howItWorks.step3',
        description: 'productPage.amendment.howItWorks.shortDescription3',
      },
    ],
    image: '/s2/raster/modern-office-review.png',
    alt: 'productPage.amendment.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.amendment.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.amendment.frequentlyAskedQuestions.faq1',
        answer: 'productPage.amendment.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.amendment.frequentlyAskedQuestions.faq2',
        answer: 'productPage.amendment.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.amendment.frequentlyAskedQuestions.faq3',
        answer: 'productPage.amendment.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  assistance: {
    title: 'productPage.amendment.needAssistance.title',
    getInTouch: 'productPage.amendment.needAssistance.getInTouch',
    actions: 'productPage.amendment.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.amendment.buyBox.buttonLabel' })
    .hasCoraOrBusinessFormedInZb()
    .businessFormed()
    .build(),
});
